/**
 * 题库
 */

 import {
    get,
    post,
    put,
    del
  } from '@/util/request'

  /**
   * 根据Id查询
   * @param {*} Id
   * @returns
   */
  export const SelectQuestionBankById = (Id) => {
    return get('/api/app/QuestionBank?CurrentId=' + Id);
  }

  /**
   * 新增数据记录
   * @param {*} data
   * @returns
   */
  export const AddQuestionBank = (data) => {
    return post('/api/app/QuestionBank', data, {});
  }

  /**
   * 更新数据记录
   * @param {*} data
   * @returns
   */
  export const ModifyQuestionBank = (data) => {
    return put('/api/app/QuestionBank', data, {});
  }

  /**
   * 分页获取
   * @param {*} data
   * @returns
   */
  export const GetDataQuestionBankList = (data) => {
    return post('/api/app/QuestionBank/list', data, {});
  }


  /**
   * 链表分页获取
   * @param {*} data
   * @returns
   */
   export const GetDataQuestionBankListByPageQuery = (data) => {
    return post('/api/app/QuestionBank/getDataByPageQuery', data, {});
  }

  /**
   * 删除记录
   * @param {*} id
   * @returns
   */
  export const DeleteQuestionBank = (id) => {
    return del('/api/app/QuestionBank/' + id, {}, {});
  }

  /**
   * 1.获取题库以及题目(不包含题目的选项)
   * @param {*} id
   * @returns
   */
   export const GetQuestionBankData = () => {
    return post('/api/app/questionBank/getQuestionBankData');
  }



